import { QuickReferenceSection } from '../types';

export const laFamigliaQuickReference: QuickReferenceSection[] = [
  {
    id: 'qr-tura-planowania',
    title: 'Tura planowania',
    content: [
      {
        type: 'numberedList',
        items: [
          'Wybierz: 1 wpływ → pole akcji albo całą kolumnę → akcja zdobywania wpływu.',
          'Zapłać 1 pieniądz właścicielowi każdego cudzego znacznika (przed przeniesieniem).',
          'Rozlicz koszt lub przychód pola.',
          'Wykonaj akcję (co najmniej jedną legalną część).',
          'Sprawdź odblokowane wartości i zaawansowane rozkazy.',
        ],
      },
    ],
    players: [2, 3, 4],
  },
  {
    id: 'qr-wydanie-rozkazu',
    title: 'Wydanie rozkazu',
    content: [
      {
        type: 'bulletList',
        items: [
          'własny Soldato w obszarze;',
          'brak innego rozkazu, chyba że zdolność pozwala;',
          'żeton z siedziby;',
          'połóż zakryty — nie odczytuj nadruku przy przeciwnikach.',
        ],
      },
    ],
    players: [2, 3, 4],
  },
  {
    id: 'qr-konflikt',
    title: 'Konflikt',
    content: [
      {
        type: 'numberedList',
        items: [
          'Zadeklaruj ruch i ewentualny samochód.',
          'Policz premie (w tym laboratoria w obronie).',
          'Wybierzcie karty konfliktu potajemnie.',
          'Ujawnijcie jednocześnie i rozpatrzcie specjalne efekty.',
          'Usuńcie straty, ustalcie kontrolę; przy zmianie kontroli usuńcie 1 laboratorium.',
        ],
      },
    ],
    players: [2, 3, 4],
  },
  {
    id: 'qr-zamach',
    title: 'Zamach',
    content: [
      {
        type: 'bulletList',
        items: [
          'tylko sąsiedni obszar lądowy;',
          'nie przez motorówki;',
          'samochód-bomba zwiększa siłę i jest usuwany;',
          'nie przejmujesz obszaru zamachem.',
        ],
      },
    ],
    players: [2, 3, 4],
  },
  {
    id: 'qr-koniec-rundy',
    title: 'Koniec rundy',
    content: [
      {
        type: 'bulletList',
        items: [
          'usuń wykonane rozkazy;',
          'zaktualizuj kontrolę Mandamenti;',
          'sprawdź 5 indywidualnie / 6 drużynowo (w 1vs1: 5 + Cupola);',
          'po 4. rundzie: liczba Mandamenti → Bronte → (poprawka) pierwszy gracz.',
        ],
      },
    ],
    players: [2, 3, 4],
  },
  {
    id: 'qr-komunikacja',
    title: 'Drużyna i komunikacja',
    content: [
      {
        type: 'bulletList',
        items: [
          'partnerzy wygrywają razem, prowadzą osobne rodziny;',
          'siedziba jawna dla partnera, tajna dla przeciwników;',
          'transfer pieniędzy: 2 → 1 dla partnera + 1 do banku;',
          'zakryty rozkaz: nie odczytuj przy przeciwnej drużynie.',
        ],
      },
    ],
    players: [2, 3, 4],
  },
];
